import axios from 'axios';
import ProgressLoader from './progressLoader';
import ErrorCodes from '@/constants/error-codes';


export default {
  get(request) {
    request.method = 'get';
    return this.doRequest(request);
  },

  put(request) {
    request.method = 'put';
    return this.doRequest(request);
  },

  post(request) {
    request.method = 'post';
    return this.doRequest(request);
  },

  delete(request) {
    request.method = 'delete';
    return this.doRequest(request);
  },

  doRequest(request) {
    const method = request.method || 'post';
    const url = request.url || '';
    const data = this.clearData(request.data);
    const queryParams = this.buildQueryParams(request.queryParams);
    const preloader = typeof (request.preloader) === 'boolean' ? request.preloader : true;

    const config = {
      method,
      url: `${process.env.VUE_APP_API_URL}/${url}${queryParams}`,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      data,
      json: true,
    };

    this.progressLoader = new ProgressLoader();

    if (preloader) {
      this.progressLoader.start();
    }

    return new Promise((resolve, reject) => {
      axios(config)
        .then(async (response) => {
          if (preloader) {
            await this.progressLoader.done();
          }
          resolve(response.data);
        })
        .catch((error) => {
          if (preloader) {
            this.progressLoader.error();
          }
          const rejectData = error.response;
          rejectData.code = rejectData.data && rejectData.data.errors
            ? rejectData.data.errors[0].code
            : ErrorCodes.UNKNOWN_SERVER_ERROR;

          reject(rejectData);
        });
    });
  },

  buildQueryParams(queryParams) {
    if (!queryParams) {
      return '';
    }

    const str = [];

    /* eslint-disable-next-line */
    for (const [key, value] of Object.entries(queryParams)) {
      if (value !== '' && value !== undefined && value !== null) {
        str.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }

    return `?${str.join('&')}`;
  },

  clearData(data) {
    if (!data) {
      return null;
    }

    const clearedData = {};

    /* eslint-disable-next-line */
    for (const [key, value] of Object.entries(data)) {
      if (value !== '' && value !== undefined && value !== null) {
        clearedData[key] = value;
      }
    }

    return clearedData;
  },
};
